import { Fragment } from 'react';
import Counter from './components/counter';
import Footer from './components/footer';
import './App.css';


function App() {

  return (
    <Fragment>
      <Counter/>
      <Footer />
    </Fragment>
  );
}

export default App;
